import axios from '../../axios'
import { IBannerAddParams, IBannerPageListData } from './inspection_banner.types'
/// 轮播文章

export function bannerAdd(params: IBannerAddParams) {
    return axios({
        method: 'post',
        url: '/inspection/banner/add',
        data: params,
    })
}

export function bannerPageList() {
    return axios<IBannerPageListData>({
        method: 'get',
        url: '/inspection/banner/pageList',
    })
}
